module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wj_wrap"
  }, [_c('div', {
    staticClass: "wj_container"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "lbl_title"
  }, [_vm._v("快递单号：")]), _vm._v(" "), _c('el-input', {
    ref: "inputExpress",
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "id": "inputBox",
      "autofocus": "",
      "placeholder": "请使用扫描枪或手动输入快递单号，回车确认",
      "disabled": _vm.disable,
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.expressNo),
      callback: function($$v) {
        _vm.expressNo = $$v
      },
      expression: "expressNo"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px",
      "width": "120px",
      "padding": "20px",
      "border-radio": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.disable
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v(_vm._s(_vm.disable ? "确认中" : "确认"))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("最近签收订单：")]), _vm._v(" "), _c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "stripe": "",
      "id": "printTable"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "flex"
          }
        }, [_c('div', {
          staticStyle: {
            "flex": "8"
          }
        }, [_c('div', [_vm._v(_vm._s(scope.row.productName))])])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "userName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.userName) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCode) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.expressNo) + "\n         ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "min-width": "60px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "70px",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "sign"
  }, [_vm._v("已签收")])]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "min-width": "80px",
      "align": "center",
      "prop": "addDate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签收时间",
      "min-width": "80px",
      "align": "center",
      "prop": "expressTime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "sign"
        }, [_vm._v(_vm._s(_vm.toDate(scope.row.expressTime, "yyyy-MM-dd")))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialog, "show", $event)
      },
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "search_result"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快递签收（" + _vm._s(_vm.expressNo.replace(/\s/g, "")) + "）")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [(_vm.msg) ? _c('div', {
    staticClass: "tip_msg"
  }, [_c('el-alert', {
    attrs: {
      "title": _vm.msg,
      "type": "error",
      "closable": false
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "size": "mini"
    }
  }, [(_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "padding": "0 30px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.vipCode) + " " + _vm._s(_vm.orderInfo && _vm.orderInfo.userName) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.orderNo) + "\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.detailList.length > 0 && _vm.orderInfo.detailList[0].productName) + "...等" + _vm._s(_vm.orderInfo && _vm.orderInfo.detailList.length) + "款\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价值："
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderInfo && _vm.orderInfo.predictTotal) + "元\n              ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间："
    }
  }, [(_vm.orderInfo && _vm.orderInfo.expressStatus == 0) ? _c('span', [_vm._v(_vm._s(_vm.toDate(_vm.orderInfo && _vm.orderInfo.addTime, "yyyy-MM-dd hh:mm")) + " 录入")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 1) ? _c('span', [_vm._v(_vm._s(_vm.toDate(_vm.orderInfo && _vm.orderInfo.expressTime, "yyyy-MM-dd hh:mm")) + " 签收")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "按回车键确认签收，按ESC取消",
      "type": "info",
      "closable": false
    }
  })], 1), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 0) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("确认签收")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo && _vm.orderInfo.expressStatus == 1) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("确认")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.orderInfo) ? _c('div', {
    staticStyle: {
      "margin-top": "50px",
      "text-align": "center"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": function($event) {
        return _vm.openOrderDailog()
      }
    }
  }, [_vm._v("补录订单")])], 1)], 1) : _vm._e()])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.orderDialog.show,
      "title": _vm.orderDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "520px",
      "center": "",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.orderDialog, "show", $event)
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.orderDialog.data,
      "rules": _vm.orderDialog.form_rules,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "expressNo",
      "label": "运单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入运单号",
      "disabled": ""
    },
    model: {
      value: (_vm.expressNo),
      callback: function($$v) {
        _vm.expressNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "expressNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "tel",
      "label": "VIP号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入VIP号",
      "maxlength": "32"
    },
    model: {
      value: (_vm.orderDialog.data.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.orderDialog.data, "vipCode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "orderDialog.data.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "goodType",
      "label": "物流公司："
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "物流公司"
    },
    model: {
      value: (_vm.orderDialog.data.expressCompany),
      callback: function($$v) {
        _vm.$set(_vm.orderDialog.data, "expressCompany", $$v)
      },
      expression: "orderDialog.data.expressCompany"
    }
  }, _vm._l((_vm.expressList), function(item) {
    return _c('el-option', {
      key: item.name,
      attrs: {
        "label": item.name,
        "value": item.name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.orderDialog.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitOrder()
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-262c4599"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/checkExpress.vue
// module id = 1227
// module chunks = 2